// extracted by mini-css-extract-plugin
export default {"shippingIcon":"_d4b247e6","title":"_19245edf"};